import { ContextRoleProfileDatasetFieldDTO, ContextRoleProfileDatasetValueDTO } from './context-role-profile-dataset-dto';
import { PageResponseDTO } from './page-response-dto';

export interface ReadContextRoleProfileDatasetResponseDTO extends PageResponseDTO {
    //    userRoles?: ContextRoleProfileDatasetDTO[];

    fields?: ContextRoleProfileDatasetFieldDTO[];
    values?: ContextRoleProfileDatasetValueDTO[];
}
